import {action, observable} from 'mobx';
import {firebaseAuth, databaseRef} from '../../helperFunctions/firebaseStore';
import IAuthStore, {IUser} from '../storeInterfaces/authStoreInterface';

export class AuthStore implements IAuthStore {

    @observable
    isAuthenticated: boolean | undefined = undefined;

    constructor() {
        this.isAuthChanged();
    }

    isAuthChanged = () => {
        firebaseAuth.onAuthStateChanged(async (user: any) => {
            if (!user) {
                this.isAuthenticated = false;
                return null;
            }
            const s = await databaseRef.ref('/users/' + user.uid).once('value');
            const userFromDB: IUser = s.val();
            this.isAuthenticated = (user && user.uid && userFromDB && userFromDB.role === 'admin');
        });
    }
    @action
    login = (email: string, password: string) => {
        return firebaseAuth.signInWithEmailAndPassword(email, password);
    }

    @action
    signOut = () => firebaseAuth.signOut()

}